import { html, render } from 'lit';
import { createRef, ref } from 'lit/directives/ref.js';

/**
 * Prompts a dialog to request user data
 *
 * @param {Object} options                    The options
 * @param {String} options.content            The content
 * @param {String} options.heading            The heading
 * @param {String} options.confirmButtonLabel The label of the confirm button
 * @param {String} options.cancelButtonLabel  The label of the cancel button
 * @param {Boolean} options.closeOnConfirm    Boolean to define if the dialog should be automatically closed on confirmation
 * @return {Promise}                          A Promise that resolves after the user adds the user selector
 */
const confirm = ( { 
    content = '', 
    heading = UncannyAutomatorBackend.i18n.utilities.confirm.heading, 
    confirmButtonLabel = UncannyAutomatorBackend.i18n.utilities.confirm.confirmButtonLabel, 
    cancelButtonLabel = UncannyAutomatorBackend.i18n.utilities.confirm.cancelButtonLabel,
    
    closeOnConfirm = true,
} ) => {
	// Create the element
	const $wrapper = document.createElement( 'div' );
	document.body.append( $wrapper );

	return new Promise( ( resolve, reject ) => {

        /**
         * Create a reference to the dialog
         *
         * @type {Ref}
         */
        const $dialog = createRef();

		render(
			html`
                <uo-dialog
                    heading="${ heading }"
                    force-manual-close
                    open

                    ${ ref( $dialog ) }
                >
                    ${ content }

                    <uo-button
                        slot="primary-action"
                        class="uap-confirm-btn-primary"

                        @click=${ () => {
                            // Check if we should close it automatically
                            if ( closeOnConfirm ) {
                                $dialog.value.close();
                            }

                            resolve( $dialog );
                        } }
                    >
                        ${ confirmButtonLabel }
                    </uo-button>

                    <uo-button
                        slot="secondary-action"
                        dialog-action="close"
                        color="secondary"
                        class="uap-confirm-btn-secondary"

                        @click=${ () => { reject(); } }
                    >
                        ${ cancelButtonLabel }
                    </uo-button>
                </uo-dialog>
			`,
			$wrapper
		);

	} );
}

export default confirm;
